import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";

const ApexPieChart = ({ utilizedBadges, assignedUsers }: any) => {
  const [options] = useState<any>({
    series: [utilizedBadges, assignedUsers],
    chart: {
      width: 244,
      type: "pie",
    },
    labels: ["Assigned Visitors", "Total Badges"], // Two labels corresponding to the two series
    legend: {
      show: false,
    },
    colors: ["#D79A2B", "#387DF5"],
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  });

  return (
    <div id="chart">
      <ReactApexChart
        options={options}
        series={options.series}
        type="pie"
        width={244}
      />
    </div>
  );
};

export default ApexPieChart;
